export const WALLET_CURRENCIES = ['USDT', 'USDC', 'ETH', 'BTC']

export const WALLET_NETWORKS = ['ETH', 'TRX', 'BTC']
